import { BSHOrder, Layer } from '../../../../config/utils/models';
import { FormattedMessage } from 'react-intl';
import globalMessages from '../../../../config/globalMessages';
import { Sync } from '@mui/icons-material';

const orderFields = [
  { ...BSHOrder.fields.dynamicCheckBox, width: 0.3, isFilterable: false },
  { ...BSHOrder.fields.id, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.group, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.pressId, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.smartlamOrderNumber, width: 1.5, isFilterable: true },
  { ...BSHOrder.fields.assignedPressString, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.woodType, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.assignedStorageString, width: 1, isFilterable: true },
  { ...BSHOrder.fields.dimensionsConvertedLengthInFeet, width: 0.9, isFilterable: true },
  { ...BSHOrder.fields.rawDimensionsConvertedAndColorized, width: 1.1, isFilterable: false },
  { ...BSHOrder.fields.iBeamNumber, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.iPressNumber, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.status, width: 0.9, isFilterable: true },
  { ...BSHOrder.fields.hasCamber, width: 0.6, isFilterable: false },
  { ...BSHOrder.fields.camberRadiusMm, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.combinedOrderColor, width: 0.4, isFilterable: false },
  { ...BSHOrder.actions.editControlOrder, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.showJDForOneOrder, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.deleteControlOrder, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.moveOrderToDone, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.setToPress, width: 0.6, isFilterable: false },
  { ...BSHOrder.actions.showBSHOrderPanel, width: 0.7, isFilterable: false },
  { ...BSHOrder.actions.printLabelRigidply, width: 0.7, isFilterable: false },
  { ...BSHOrder.fields.pressingMatrix, width: 0.5, isFilterable: false },
  { ...BSHOrder.fields.pressedMatrix, width: 0.5, isFilterable: false },
  { ...BSHOrder.fields.draggableArea, width: 0.7, isFilterable: false }
];

const finishedOrderFields = [
  { ...BSHOrder.fields.dynamicCheckBox, width: 0.3, isFilterable: false },
  { ...BSHOrder.fields.id, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.group, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.pressId, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.smartlamOrderNumber, width: 1.5, isFilterable: true },
  { ...BSHOrder.fields.assignedPressString, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.assignedStorageString, width: 1, isFilterable: true },
  { ...BSHOrder.fields.woodType, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.dimensionsConvertedLengthInFeet, width: 0.9, isFilterable: true },
  { ...BSHOrder.fields.iBeamNumber, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.iPressNumber, width: 0.5, isFilterable: true },
  { ...BSHOrder.fields.status, width: 0.9, isFilterable: true },
  { ...BSHOrder.fields.hasCamber, width: 0.6, isFilterable: false },
  { ...BSHOrder.fields.camberRadiusMm, width: 0.7, isFilterable: true },
  { ...BSHOrder.fields.combinedOrderColor, width: 0.4, isFilterable: false },
  { ...BSHOrder.actions.editControlOrder, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.showJDForOneOrder, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.deleteControlOrder, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.moveOrderToDone, width: 0.5, isFilterable: false },
  { ...BSHOrder.actions.setToPress, width: 0.6, isFilterable: false },
  { ...BSHOrder.actions.showBSHOrderPanel, width: 0.7, isFilterable: false },
  { ...BSHOrder.actions.moveOrderToActive, width: 0.7, isFilterable: false },
  { ...BSHOrder.actions.printLabelRigidply, width: 0.7, isFilterable: false }
];

const layerFields = [
  { ...Layer.fields.id, width: 0.7 },
  { ...Layer.fields.layer_erp_id, width: 1.2 },
  { ...Layer.fields.layerNo, width: 0.5 },
  { ...Layer.fields.rawDimensionsConvertedAndColorized, width: 1.2 },
  { ...Layer.fields.lamellaDimensionsConverted, width: 1.2 },
  { ...Layer.fields.finalBeamDimensionsConverted, width: 1.2 },
  { ...Layer.fields.numOfLamellas, width: 0.5 },
  { ...Layer.fields.crown, width: 0.5 },
  { ...Layer.fields.topTension, width: 0.5 },
  { ...Layer.fields.topN1D, width: 0.5 },
  { ...Layer.fields.coreN1M, width: 0.5 },
  { ...Layer.fields.bottomN1D, width: 0.5 },
  { ...Layer.fields.bottomTension, width: 0.5 },
  { ...Layer.fields.assignedToEtage, width: 0.5 },
  { ...Layer.fields.orderColor, width: 0.7 },
  { ...Layer.fields.inEtage, width: 0.7 },
  { ...Layer.actions.printSticker, width: 0.7 }
];

const colorsOrder = function (item) {
  let color = '#FFFFFF';

  if (item.status === 'pressing') {
    color = 'rgba(119, 221, 119, 0.35)';
  } else if (item.status === 'waiting for press') {
    color = '#FFCF9E';
  } else if (item.status === 'done') {
    color = 'rgba(24, 89, 41, 0.35)';
  } else if (item.status === 'jointing') {
    color = 'rgba(19, 101, 160, 0.35)';
  } else {
    color = '#FFFFFF';
  }

  return color;
};

const orders = [orderFields, finishedOrderFields];
const multipleOrderView = true;
const label = <FormattedMessage {...globalMessages.orders} identifier={'orders'} />;

const ordersList = {
  orderFields: {
    string: <FormattedMessage {...globalMessages.ordersInProducing} identifier={'activeOrders'} />,
    dataSet: orderFields,
    data: 'orderQueue'
  },
  finishedOrderFields: {
    string: <FormattedMessage {...globalMessages.ordersInDone} identifier={'finishedOrders'} />,
    dataSet: finishedOrderFields,
    data: 'lastFewOrdersPressed'
  }
};

const buttons = {
  syncOrders: {
    style: {},
    label: 'syncOrders',
    icon: <Sync />,
    action: 'sync-lastFewPressed-orders',
    dataSet: 'lastFewOrdersPressed'
  }
};

const defaultOrdersQueueConfig = {
  orderFields,
  layerFields,
  orders,
  multipleOrderView,
  showFilterRowByDefault: false,
  ordersList,
  colors: colorsOrder,
  label,
  buttons
};

export default defaultOrdersQueueConfig;
